import {
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  TextField,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  GetAllPaymentAction,
  GetAllPaymentdataAction,
} from "../../../../../redux/actions/PaymentAction";
import { createApplicationAction } from "../../../../../redux/actions/ApplicationAction";
import notify from "../../../../../Notifcation";
import { ToastContainer } from "react-toastify";
import { Spinner } from "react-bootstrap";
import { useNavigate } from "react-router-dom";

const Online = () => {
  const [esal, setesal] = useState("");
  const [feedback, setfeedback] = useState("");
  const All = useSelector((state) => state.PaymentReduser.GetallPay);
  const One = useSelector((state) => state.PaymentReduser.GetPaydata);
  const navegate = useNavigate();

  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(GetAllPaymentAction());
  }, []);
  const idcar = localStorage.getItem("id_car");
  const [loading, setLoading] = useState(true);
  const [isPress, setisPress] = useState(false);
  const handlesubmit = async (e) => {
    e.preventDefault();
    setisPress(true);
    const formData = new FormData();
    formData.append("application_type", 1);
    formData.append("car_id", idcar);
    formData.append("comment", feedback);
    formData.append("payment_type", "cash");
    formData.append("payment_receipt", esal);
    await dispatch(createApplicationAction(formData));
    setLoading(false);
    setesal("");
    setfeedback("");
    setisPress(false);
  };
  const res = useSelector((state) => state.ApplicationReduser.createApp);

  useEffect(() => {
    if (loading === false) {
      setTimeout(() => setLoading(true), 1500);
      if (res) {
        if (res.status === 201 || res.status === 200) {
          if (res.data) {
            notify(res.data.message, "success");
            setTimeout(() => {
              navegate("/user/requestsuser");
            }, 3000);
          }
        } else if (res.status !== 201 || res.status !== 200) {
          if (res.data) {
            notify(res.data.message, "error");
          } else {
            notify("حدثة مشكلة حاول مرة اخرى", "error");
          }
        }
      }
    }
  }, [loading]);
  return (
    <div>
      <h3 className="text-center mb-3 mt-3">
        يمكن الدفع عبر الأنترنت من خلال الطرق الأتية
      </h3>
      <div className="attachment text-center">
        <div className="inp">
          <FormControl fullWidth>
            <InputLabel id="demo-simple-select-label"> طرق الدفع</InputLabel>
            <Select
              labelId="demo-simple-select-label"
              id="demo-simple-select"
              label="طرق الدفع"
              onChange={(e) => {
                dispatch(GetAllPaymentdataAction(e.target.value));
              }}
            >
              {All && All.length >= 0
                ? All.map((item,idx) => (
                    <MenuItem key={idx} value={item.payment_type}>
                      {item.payment_type}
                    </MenuItem>
                  ))
                : null}
            </Select>
          </FormControl>
          {One && One.value ? (
            <h5 className="mt-3 mb-3">
              رقم الحساب الخاص ب {One.type} هو {One.value}
            </h5>
          ) : null}
        </div>
        <div className="inp">
          <TextField
            label="قم برفع الإيصال"
            focused
            type="file"
            // value={esal.name}
            onChange={(e) => {
              setesal(e.target.files[0]);
            }}
            variant="outlined"
          />
        </div>
        <div className="inp">
          <TextField
            label="ملاحظات"
            type="text"
            value={feedback}
            onChange={(e) => {
              setfeedback(e.target.value);
            }}
            variant="outlined"
          />
        </div>
        {isPress && loading ? (
          <button className="buttonadd">
            <Spinner />
          </button>
        ) : (
          <button className="buttonadd" onClick={handlesubmit}>
            {" "}
            استكمال الطلب
          </button>
        )}
      </div>
      <ToastContainer />
    </div>
  );
};

export default Online;
